import { DictionaryValuesService } from '../../shared/services/dictionaryValues.service';
import { SitesService } from '../../shared/services/sites.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { trigger, state, style } from '@angular/animations';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute } from '@angular/router';

import { DatatableBaseComponent } from '@components/datatable-base.component';
import { UiService } from '@services/ui.service';
import { DictionaryValue } from '@classes/dictionary/dictionaryValue';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { UsersService } from '@services/users.service';

@Component({
  selector: 'app-dictionaries',
  templateUrl: './dictionaries.component.html',
  styleUrls: ['./dictionaries.component.scss'],
  animations: [
    trigger('detailExpand', [
      state(
        'collapsed',
        style({ height: '0px', minHeight: '0', display: 'none' }),
      ),
      state('expanded', style({ height: '*' })),
    ]),
  ],
})
export class DictionariesComponent
  extends DatatableBaseComponent
  implements OnInit
{
  transportTypes: DictionaryValue[];
  urgencyLevels: DictionaryValue[];
  lots: DictionaryValue[];

  @ViewChild('TransportTypesSort', { static: true })
  public transportTypesSort: MatSort;
  @ViewChild('UrgencyLevelsSort', { static: true })
  public urgencyLevelsSort: MatSort;
  @ViewChild('TransportTypesPaginator', { static: true })
  transportTypesPaginator: MatPaginator;
  @ViewChild('UrgencyLevelsPaginator', { static: true })
  urgencyLevelsPaginator: MatPaginator;

  constructor(
    protected uiSrv: UiService,
    private route: ActivatedRoute,
    private dictionaryValuesSrv: DictionaryValuesService,
    private _usersService: UsersService,
  ) {
    super(uiSrv);
  }

  ngOnInit() {
    super.ngOnInit();
    this.getRouteData();
    this.initSubscriptions();
  }

  private getRouteData(): void {
    this.route.data.subscribe(
      (data: {
        transportTypes: DictionaryValue[];
        urgencyLevels: DictionaryValue[];
        lots: DictionaryValue[];
      }) => {
        this.transportTypes = data.transportTypes;
        this.urgencyLevels = data.urgencyLevels;
        this.lots = data.lots;
        // this.initTable();
      },
    );
  }

  private initSubscriptions(): void {
    this.addSubscription(
      this.dictionaryValuesSrv.transportTypesListChanged.subscribe(
        (dictionaryValues) => {
          this.transportTypes = dictionaryValues || [];
          this.onEditFinished();
        },
      ),
    );

    this.addSubscription(
      this.dictionaryValuesSrv.urgencyLevelsListChanged.subscribe(
        (dictionaryValues) => {
          this.urgencyLevels = dictionaryValues || [];
          this.onEditFinished();
        },
      ),
    );

    this.addSubscription(
      this.dictionaryValuesSrv.lotsListChanged.subscribe((dictionaryValues) => {
        this.lots = dictionaryValues || [];
        this.onEditFinished();
      }),
    );

    this.addSubscription(
      this._usersService.globalSelectedClientSubject.subscribe(() => {
        this.dictionaryValuesSrv.getTransportList().subscribe();
        this.dictionaryValuesSrv.getUrgencyList().subscribe();
        this.dictionaryValuesSrv.getLotsList().subscribe();
      }),
    );
  }
}
